import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";

type ButtonVariant = 'default' | 'outlined' | 'text' | 'color-fill';
type Alignment = 'center' | 'between';

interface ButtonIcon {
  name: string;
  color?: string;
  isFilled?: boolean;
  svgPath?: string;
  rotating?: boolean;
}

@Component({
    selector: 'kt-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit, OnChanges {

    @Input() padding = '8px';
    @Input() noPadding = false;
    @Input() noFullWidth: boolean = false;
    @Input() variant: ButtonVariant = 'default'; //default --> filled
    @Input() startIcon?: ButtonIcon;
    @Input() endIcon?: ButtonIcon;
    @Input() label: string = '';
    @Input() labelColor: string = 'black';
    @Input() labelSize?: string = '14px';
    @Input() color?: string;  //default ---> background-color , outlined ---> border color
    @Input() navigateTo;
    @Input() itemAlignment: Alignment;
    @Input() disabled: boolean = false;
    @Input() disableStyle: boolean = false;
    @Input() tooltip?: string;
    /** Optional accessible name when visible `label` is empty (icon-only). */
    @Input() accessibleLabel?: string;
    @Input() image?: string;


    buttonStyles: any;
    startIconStyles: any;
    endIconStyles: any;
    labelStyles: any;

    @Output() onClick = new EventEmitter<string>();
    btnClicked(data) {
        this.onClick.emit(data);
    }

    ngOnInit(): void {
        this.setButtonStyles();
        this.setStartIconStyles();
        this.setEndIconStyles();
        this.setLabelStyles();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['color'] || changes['textColor'] || changes['startIcon'] || changes['variant'] || changes['disabled'] || changes['labelColor'] || changes['labelSize'] || changes['disableStyle'] || changes['label'] || changes['image'] || changes['padding'] || changes['noFullWidth'] || changes['noPadding']) {
            this.setButtonStyles();
            this.setStartIconStyles();
            this.setEndIconStyles();
            this.setLabelStyles();
            if (this.disableStyle) {
                Object.assign(this.startIconStyles, {
                    'color': '#18181B'
                })
            }
        }
    }

    //to change the label colour on disable state
    get computedLabelColor(): string {
        return (this.disabled && this.disableStyle) ? '#1010104D' : this.labelColor;
    }

    setLabelStyles() {
        this.labelStyles = {
            'color': this.computedLabelColor,
            ...(this.labelSize && { 'font-size': this.labelSize })
        };
    }

    setButtonStyles() {
        if(this.variant == 'default') {
            this.buttonStyles = {
                'background-color': this.color || 'transparent',
                'border-radius': '6px',
                'border': 'none',
                'box-shadow': '0px 1px 2px 0px rgba(0, 0, 0, 0.05)'
            }
        } else if(this.variant == 'outlined') {
            this.buttonStyles = {
                'background-color': 'transparent',
                'border-radius': '6px',
                'border': this.color ? `1px solid ${this.color}` : 'none',
                'box-shadow': '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
            }
        } else if(this.variant == 'text') {
            this.buttonStyles = {
                'background-color': 'transparent',
                'border': 'none'
            }
        } else if(this.variant == 'color-fill'){
            this.buttonStyles = {
                'background-color': this.color || 'transparent',
                'border-radius': '6px',
                'border': this.color ? `1px solid #E4E4E7` : 'none',
                'box-shadow': '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
            }
        } else if(this.variant == 'just-icon'){
            this.buttonStyles = {
                'background-color': 'transparent',
                'border-radius': '0',
                'border': 'none',
                'box-shadow': 'unset',
            }
        }
        this.buttonStyles['justify-content'] = this.itemAlignment == 'between' ? 'space-between' : 'center'
        this.buttonStyles['padding'] = this.padding ?? '8px';
        if (this.disabled) {
            Object.assign(this.buttonStyles, {
                'cursor': 'not-allowed',
            });
            if (this.disableStyle) {
                Object.assign(this.buttonStyles, {
                    'cursor': 'not-allowed',
                    'background-color': 'transparent',
                    'border': '1px solid #E4E4E7',
                    'box-shadow': '0px 1px 2px 0px #0000000D',
                    // 'opacity': '0.5'
                });
            }
        }
        if (this.noPadding) {
            this.buttonStyles['padding'] = 0;
        }
        if (this.noFullWidth) {
            this.buttonStyles['width'] = 'unset';
        } else {
            this.buttonStyles['width'] = '100%';
        }
    }


    setStartIconStyles() {
        this.startIconStyles = {
            'color': this.startIcon?.color ?? '#18181B'
        }
    }

    setEndIconStyles() {
        this.endIconStyles = {
            'color': this.endIcon?.color ?? '#18181B'
        }
    }


}